module.exports = __webpack_public_path__ + "img/sharing.788e2a85.png";